// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/change_transfer_status.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { TransferHistoryStatus } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ChangeTransferStatusRequest
 */
export class ChangeTransferStatusRequest extends Message<ChangeTransferStatusRequest> {
  /**
   * The ID of the transfer to change the status for.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId = "";

  /**
   * The new status to set for the transfer.
   *
   * @generated from field: com.neulink.pharmacy.TransferHistoryStatus new_status = 2;
   */
  newStatus = TransferHistoryStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<ChangeTransferStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ChangeTransferStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transfer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_status", kind: "enum", T: proto3.getEnumType(TransferHistoryStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeTransferStatusRequest {
    return new ChangeTransferStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeTransferStatusRequest {
    return new ChangeTransferStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeTransferStatusRequest {
    return new ChangeTransferStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeTransferStatusRequest | PlainMessage<ChangeTransferStatusRequest> | undefined, b: ChangeTransferStatusRequest | PlainMessage<ChangeTransferStatusRequest> | undefined): boolean {
    return proto3.util.equals(ChangeTransferStatusRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ChangeTransferStatusResponse
 */
export class ChangeTransferStatusResponse extends Message<ChangeTransferStatusResponse> {
  constructor(data?: PartialMessage<ChangeTransferStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ChangeTransferStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeTransferStatusResponse {
    return new ChangeTransferStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeTransferStatusResponse {
    return new ChangeTransferStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeTransferStatusResponse {
    return new ChangeTransferStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeTransferStatusResponse | PlainMessage<ChangeTransferStatusResponse> | undefined, b: ChangeTransferStatusResponse | PlainMessage<ChangeTransferStatusResponse> | undefined): boolean {
    return proto3.util.equals(ChangeTransferStatusResponse, a, b);
  }
}

